import { JOURNEY_TEMPLATE_TYPE, BILLING_CADENCE_TYPE } from 'shared/enums';

export const billingCadenceSchemaOptions = [
  { value: BILLING_CADENCE_TYPE.DAY, label: 'Daily' },
  { value: BILLING_CADENCE_TYPE.MONTH, label: 'Monthly' },
  { value: BILLING_CADENCE_TYPE.WEEK, label: 'Weekly' },
  { value: BILLING_CADENCE_TYPE.YEAR, label: 'Yearly' }
];

export const eCommercePlatforms = {
  TELEGRA_COMMERCE: 'telegra_commerce'
};
